import { BREED_LABELS } from "@/lib/api";

// Hiyerarşik çoklu kümes seçimi: Ana Kümes (parent) -> Alt Kümesler (child), cascade + indeterminate
export function CoopTree({ coops, value, onChange, testidPrefix = "tree" }) {
  const locations = coops.filter((c) => c.type === "location");
  const childrenOf = (locId) => coops.filter((c) => c.type === "coop" && c.parent_id === locId);
  const set = new Set(value || []);

  const toggleChild = (id) => {
    const n = new Set(set);
    n.has(id) ? n.delete(id) : n.add(id);
    onChange([...n]);
  };
  const toggleParent = (locId) => {
    const kids = childrenOf(locId).map((c) => c.id);
    const allOn = kids.length > 0 && kids.every((k) => set.has(k));
    const n = new Set(set);
    kids.forEach((k) => (allOn ? n.delete(k) : n.add(k)));
    onChange([...n]);
  };
  const parentState = (locId) => {
    const kids = childrenOf(locId).map((c) => c.id);
    const on = kids.filter((k) => set.has(k)).length;
    if (on === 0) return "none";
    if (on === kids.length) return "all";
    return "some";
  };

  const allChildIds = coops.filter((c) => c.type === "coop").map((c) => c.id);

  return (
    <div data-testid={`${testidPrefix}-root`}>
      <div className="flex gap-2 mb-2">
        <button type="button" onClick={() => onChange(allChildIds)} data-testid={`${testidPrefix}-all`} className="text-xs px-2 py-1 rounded-md bg-secondary hover:bg-secondary/70">Tümünü Seç</button>
        <button type="button" onClick={() => onChange([])} data-testid={`${testidPrefix}-clear`} className="text-xs px-2 py-1 rounded-md bg-secondary hover:bg-secondary/70">Seçimleri Temizle</button>
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto rounded-lg border border-border p-3">
        {locations.map((loc) => {
          const st = parentState(loc.id);
          return (
            <div key={loc.id}>
              <label className="flex items-center gap-2 font-semibold text-sm cursor-pointer" data-testid={`${testidPrefix}-loc-${loc.id}`}>
                <input type="checkbox" checked={st === "all"} ref={(el) => { if (el) el.indeterminate = st === "some"; }}
                  onChange={() => toggleParent(loc.id)} className="h-4 w-4 accent-primary" />
                {loc.name} Kümesi
              </label>
              <div className="ml-6 mt-1 space-y-1">
                {childrenOf(loc.id).map((c) => (
                  <label key={c.id} className="flex items-center gap-2 text-sm cursor-pointer" data-testid={`${testidPrefix}-coop-${c.id}`}>
                    <input type="checkbox" checked={set.has(c.id)} onChange={() => toggleChild(c.id)} className="h-4 w-4 accent-primary" />
                    {c.name} <span className="text-[11px] text-muted-foreground">({BREED_LABELS[c.breed] || "-"})</span>
                  </label>
                ))}
                {childrenOf(loc.id).length === 0 && <div className="text-xs text-muted-foreground">Alt kümes yok</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
